import AddNewButton from 'Components/Generic/Buttons/AddNewButton';
import { SITE_PAGES } from 'Config';
import { user_roles } from 'Data/Enum';
import SiteDrawerData from 'Data/SiteDrawerData';
import { isUserAuthorized } from 'Util';
import AdminLanding from './AdminLanding';
import OrganizationDetails from './Organizations/OrganizationDetails';
import OrganizationListView from './Organizations/OrganizationListView';

const ManageOrgsView = () => {
  let breadcrumb = [SITE_PAGES.MANAGE_FACILITIES];

  let drawerContent = (
    <OrganizationDetails compact editable hideToggle parentEditState={true} />
  );
  const onClick = () => {
    SiteDrawerData.open({
      content: drawerContent,
      title: 'New Core Facility',
      size: { defaultWidth: 680, minWidth: 580 },
    });
  };

  let addNewButton = isUserAuthorized({
    roles: [user_roles.ADMINISTRATOR],
  }) && (
    <AddNewButton
      buttonText='Add Core Facility'
      clickHandler={onClick}
      tableButton
    />
  );

  return (
    <AdminLanding breadcrumbs={breadcrumb}>
      <OrganizationListView addNewOrgButton={addNewButton} />
    </AdminLanding>
  );
};

export default ManageOrgsView;
